<div class="modal-header" id="material-pickup-modal-title">
    <h3 class="modal-title" id="modal-title" translate="MATERIAL_PICKUP_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>

<div class="modal-body" id="modal-body">
    <form [formGroup]="materialPickupForm">
        <fieldset formArrayName="formChildren">
            <div class="row mb-3 align-items-center" *ngIf="dopModel">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_DROP_OFF_POINT_DOP_DESC"
                ></label>
                <div class="col-6 col-sm-8">
                    <p *ngFor="let info of dopInfo">{{ info }}</p>
                </div>
            </div>
            <div class="row mb-3 align-items-center" *ngIf="material.textLine">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_TEXT_LINE"
                ></label>
                <div class="col-6 col-sm-8">
                    <p>{{ material.textLine }}</p>
                </div>
            </div>
            <hr *ngIf="dopModel || material.textLine" class="separator" />
            <div class="row mb-3 align-items-center" *ngIf="displayBatchNumber">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    *ngIf="displayBatchNumber"
                    translate="MATERIAL_PICKUP_BATCHNR_LABEL"
                ></label>
                <pace-core-text-input
                    class="col-4"
                    [(model)]="model.selectedPartSet.awb"
                    [parentForm]="materialPickupFormChildren"
                    [ariaLabel]="'MATERIAL_PICKUP_BATCHNR_LABEL' | translate"
                ></pace-core-text-input>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_ORDER_LABEL"
                ></label>
                <div class="col-6 col-sm-8">{{ model.selectedPartSet.orderNumber.value }}</div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_ORDER_POSITION_LABEL"
                ></label>
                <div class="col-6 col-sm-8">{{ model.selectedPartSet.orderPosition.value }}</div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_MATERIAL_NUMBER_LABEL"
                ></label>
                <div class="col-6 col-sm-8">{{ model.selectedPartSet.materialNumber.value }}</div>
            </div>
            <div class="row mb-3 align-items-center" *ngIf="model.batchNumber">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_BATCHNR_LABEL"
                ></label>
                <div class="col-6 col-sm-8">{{ model.batchNumber }}</div>
            </div>
            <div class="row mb-3 align-items-center" *ngIf="model.ucrNumber">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_UCR_NUMBER_LABEL"
                ></label>
                <div class="col-6 col-sm-8">{{ model.ucrNumber }}</div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_DELIVERYQUANTITY_LABEL"
                ></label>
                <div class="col-6 col-sm-8">{{ model.deliveryQuantity }}</div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                    translate="MATERIAL_PICKUP_QUANTITY_LABEL"
                ></label>
                <div class="col-6">
                    <pace-core-number-stepper
                        id="quantity"
                        name="quantity"
                        [(model)]="model.selectedPartSet.quantity"
                        [parentForm]="materialPickupFormChildren"
                        [ariaLabel]="'MATERIAL_PICKUP_QUANTITY_LABEL' | translate"
                    ></pace-core-number-stepper>
                </div>
            </div>
            <div *ngIf="displayPickupRFID" class="row mb-3 align-items-center">
                <label
                    translate="MATERIAL_PICKUP_AWB_RFID"
                    class="col-6 col-sm-4 col-form-label text-sm-end text-start"
                ></label>
                <div class="col-6">
                    <pace-core-text-input
                        id="pickupRfid"
                        [(model)]="model.selectedPartSet.pickupRfid"
                        [parentForm]="materialPickupFormChildren"
                    ></pace-core-text-input>
                </div>
            </div>
            <ng-container *ngIf="model.selectedPartSet.feedbackRating && model.selectedPartSet.feedbackComment">
                <hr class="separator" />
                <div class="row mb-3 align-items-center">
                    <label class="col-4 col-form-label" translate="MATERIAL_PICKUP_FEEDBACK_RATING_LABEL"></label>
                    <div class="col-6 col-sm-8">
                        <pace-core-rating-input
                            [(model)]="model.selectedPartSet.feedbackRating"
                            [parentForm]="materialPickupFormChildren"
                            (valueChange)="updateFeedbackComment()"
                            [ariaLabel]="'MATERIAL_PICKUP_FEEDBACK_RATING_LABEL' | translate"
                        ></pace-core-rating-input>
                    </div>
                </div>
                <div class="row mb-3 align-items-center">
                    <label class="col-4 col-form-label" translate="MATERIAL_PICKUP_FEEDBACK_COMMENT_LABEL"></label>
                    <div class="col-6 col-sm-8">
                        <pace-core-text-input
                            [(model)]="model.selectedPartSet.feedbackComment"
                            [parentForm]="materialPickupFormChildren"
                            [ariaLabel]="'MATERIAL_PICKUP_FEEDBACK_COMMENT_LABEL' | translate"
                        ></pace-core-text-input>
                    </div>
                </div>
            </ng-container>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!isLoading">
        <button
            class="btn btn-warning me-auto"
            *ngIf="displayNotReceived"
            [disabled]="!checkValidQuantity()"
            (click)="setNotReceived()"
            translate="MATERIAL_PICKUP_NOTRECEIVED_LABEL"
        ></button>
        <button
            class="btn btn-primary"
            (click)="sendPickup()"
            [disabled]="materialPickupForm.invalid"
            translate="MATERIAL_PICKUP_SEND_PICKUP_LABEL"
        ></button>
    </ng-container>
    <progressbar type="default" [value]="100" *ngIf="isLoading">Sending request...</progressbar>
</div>
